import { RouteConfig } from 'vue-router';

const routes: RouteConfig = {
  path: '/auth',
  component: () => import(/* webpackChunkName: 'auth' */ '@/pages/auth/Index.vue'),
  redirect: {
    name: 'auth-login',
  },
  children: [
    {
      path: 'login',
      name: 'auth-login',
      component: () => import(/* webpackChunkName: 'auth' */ '@/pages/auth/Login.vue'),
    },
    {
      path: 'forgot-password',
      name: 'auth-forgot-password',
      component: () => import(/* webpackChunkName: 'auth' */ '@/pages/auth/ForgotPassword.vue'),
    },
    {
      path: 'logout',
      name: 'auth-logout',
      component: () => import(/* webpackChunkName: 'auth' */ '@/pages/auth/Logout.vue'),
    },
  ],
};

export default routes;
